/* eslint-disable react/no-set-state */
import PropTypes from 'prop-types';

import React, { Component } from 'react';
import OutsideClick from '../outsideClick';
import './index.scss';

export default class DropdownIcon extends Component {
  static propTypes = {
    items: PropTypes.any,
    label: PropTypes.any,
    value: PropTypes.any,
  };

  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  onOpen() {
    this.setState({
      isOpen: true,
    });
  }

  onClose() {
    this.setState({
      isOpen: false,
    });
  }

  render() {
    const { label, items, value } = this.props;
    const { isOpen } = this.state;
    return (
      <a className="dropdown-icon">
        <span onClick={() => this.onOpen()}>{label}</span>
        {isOpen && (
          <OutsideClick
            onClickOutside={() => this.onClose()}
            onRender={() => (
              <div className="dropdown-content">
                {items.map((item, i) => (
                  <div key={i} onClick={() => item.onClick(value)}>
                    {item.label}
                  </div>
                ))}
              </div>
            )}
          />
        )}
      </a>
    );
  }
}
